import { Link } from 'react-router-dom'
import './Button.css'

/**
 * Componente Button - Botão reutilizável
 * 
 * @param {string} variant - Variante do botão: 'primary', 'secondary', 'ghost'
 * @param {string} size - Tamanho: 'sm', 'md', 'lg'
 * @param {string} to - URL para navegação (usa Link do react-router)
 * @param {string} href - URL externa (usa <a>)
 * @param {boolean} disabled - Estado desabilitado
 * @param {function} onClick - Função de callback
 * @param {string} className - Classes CSS adicionais
 * @param {React.ReactNode} children - Conteúdo do botão
 */
function Button({
  variant = 'primary',
  size = 'md',
  to,
  href,
  disabled = false,
  onClick,
  className = '',
  children,
  type = 'button',
  ...props
}) {
  const baseClasses = `btn btn-${variant} btn-${size} ${className}`.trim()

  // Se tiver 'to', usa Link do react-router
  if (to) {
    return (
      <Link
        to={to}
        className={baseClasses}
        onClick={disabled ? (e) => e.preventDefault() : onClick}
        aria-disabled={disabled}
        {...props}
      >
        {children}
      </Link>
    )
  }

  // Se tiver 'href', usa <a>
  if (href) {
    return (
      <a
        href={href}
        className={baseClasses}
        onClick={disabled ? (e) => e.preventDefault() : onClick}
        aria-disabled={disabled}
        {...props}
      >
        {children}
      </a>
    )
  }

  // Caso padrão: <button>
  return (
    <button
      type={type}
      className={baseClasses}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  )
}

export default Button

